import { Fragment, useRef } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { ClipboardCopyIcon } from '@heroicons/react/outline'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faFacebook, faLinkedin, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FacebookShareButton, LinkedinShareButton, WhatsappShareButton, TwitterShareButton } from "react-share";
import { useDispatch } from 'react-redux';
import { editLastVisitedMicroskill, editRedirectType } from '../../redux/actions/userActivity';

const SharePopup = ({ open, setOpen, customURL, nativeShare, mSkill }) => {
  const shareURL = customURL ? window.location.origin + customURL : window.location.href
  const cancelButtonRef = useRef(null)
  const dispatch = useDispatch()

  function linkedinAuth() {
    try {
      dispatch(editRedirectType("linkedin"))
      dispatch(editLastVisitedMicroskill(mSkill))

      const client_id = '78d1eot06iq0ru';
      // console.log(client_id)
      const url = `https://www.linkedin.com/oauth/v2/authorization?client_id=${client_id}&redirect_uri=http://localhost:3000/redirect&response_type=code&scope=w_member_social r_liteprofile r_emailaddress`
      window.location.href = url
      return { success: true }
    } catch (err) {
      console.log(err)
      return { success: false }
    }
  }

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="fixed z-10 inset-0 overflow-y-auto" initialFocus={cancelButtonRef} onClose={setOpen}>
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="relative inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-auto">
              <div className="bg-white px-4 pt-5 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                    <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                      Share this video!!!
                    </Dialog.Title>
                    <div className="flex mt-4">
                      <p className="text-base p-2 text-gray-500 border-2 border-gray-600 rounded-md">
                        {shareURL}
                      </p>
                      <ClipboardCopyIcon className="h-10 w-8 ml-2 text-gray-600 cursor-pointer" aria-hidden="true" onClick={() => navigator.clipboard.writeText(shareURL)} />
                    </div>
                    <div className="md:flex justify-center mt-4">
                      <FacebookShareButton
                        url={"https://app.learntube.ai"}
                        quote={"Learntube - Now you can learn anything from anywhere by using CareerNinja's LearnTube App."}
                        hashtag="#learntube"
                        className="md:mr-6 mr-4 text-gray-500">
                        <FontAwesomeIcon size='xl' icon={faFacebook} />
                      </FacebookShareButton>
                      {
                        !nativeShare ? <LinkedinShareButton
                          url={"https://app.learntube.ai" + window.location.pathname}
                          title={"Learntube - Now you can learn anything from anywhere by using CareerNinja's LearnTube App."}
                          className="md:mr-6 mr-4 text-gray-500">
                          <FontAwesomeIcon size='xl' icon={faLinkedin} />
                        </LinkedinShareButton> :
                          <FontAwesomeIcon icon={faLinkedin} className="md:mr-6 mr-4 text-black cursor-pointer" size='xl' onClick={
                            (e) => {
                              e.stopPropagation()
                              linkedinAuth()
                            }
                          } />
                      }
                      <WhatsappShareButton
                        url={"https://app.learntube.ai" + window.location.pathname}
                        title={"Learntube - Now you can learn anything from anywhere by using CareerNinja's LearnTube App."}
                        className="md:mr-6 mr-4 text-gray-500">
                        <FontAwesomeIcon size='xl' icon={faWhatsapp} />
                      </WhatsappShareButton>
                      <TwitterShareButton
                        title={"Learntube - Now you can learn anything from anywhere by using CareerNinja's LearnTube App."}
                        url={"https://app.learntube.ai" + window.location.pathname}
                        via={"CareerNinjaIn"}
                        hashtags={["learntube", "careerninja"]}
                        className="md:mr-6 mr-4 text-gray-500">
                        <FontAwesomeIcon size='xl' icon={faTwitter} />
                      </TwitterShareButton>
                    </div>
                  </div>
                </div>
              </div>
              <div className="px-4 pb-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => setOpen(false)}
                  ref={cancelButtonRef}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  )
}

export default SharePopup